module.exports = __webpack_public_path__ + "img/GUIDE-RAIL-AND-BALANCE-SYSTEM.7a831daf.jpg";